import axios from 'axios'
import Const from '@/helpers/const'

export default {
  auth (params) {
    return axios.post(`${Const.API_AUTH_URL}`, params)
  }
}
